export const APP_CONFIG = {
  WEBSITE_URL: "https://www.heybodhi.ai",
  PRIVACY_POLICY_URL: "https://heybodhi.ai/english-privacy-policy",
  TERMS_AND_CONDITIONS_URL: "https://heybodhi.ai/terms-conditions",
  /**
   * Effective date of the Terms & Conditions version currently in force.
   * Compared with `users.terms_effective_date` on sign-in — a mismatch (or
   * NULL on the user row) means the user must re-accept.
   * Bump this when the Terms & Conditions are updated; no DB migration needed.
   * See AE-174 / AE-176 (AE-176 will move this to a server-side setting).
   */
  CURRENT_TERMS_EFFECTIVE_DATE: "2026-01-01",
  /**
   * Effective date of the Privacy Policy version currently in force.
   * Compared with `users.privacy_effective_date` on sign-in — a mismatch (or
   * NULL on the user row) means the user must re-accept.
   * Bump this when the Privacy Policy is updated; no DB migration needed.
   * See AE-174 / AE-176 (AE-176 will move this to a server-side setting).
   */
  CURRENT_PRIVACY_EFFECTIVE_DATE: "2026-01-01",
};
